import { Link } from "react-router-dom"
import cursor from "../assets/img/cursor.png"


const Gallery = () => {
    return (
    <div>
    <Link to="/"><img id='menu1' src={cursor} alt='menu' title="Home"></img></Link> 
    <Link to="/Illustration"><p className='sub' id='menu0'>Illustrations</p></Link> 
    <Link to="/Clo"><p className='sub' id='menu2'>CLO3D</p></Link> 
    <Link to="/Effects"><p className='sub' id='menu3'>Spark AR Archive</p></Link>       
    </div>
    );
    
  };
  
  export default Gallery;